/**
 * PRODUCT SALES (SHOPPING) objective — Standard Shopping campaigns off a
 * linked Merchant Center feed. Pages: ShoppingPage (workspace),
 * ShoppingCampaignWizard, CreateShoppingAdgroup, CreateShoppingAd. The shared
 * editors, preview and helpers live in src/components/google-ads/shopping/.
 */
import { Store } from 'lucide-react';
import { ShoppingObjectiveConfig } from '@/components/google-ads/shopping/shoppingShared';

export const SHOPPING_BASE = '/google-ads/shopping';
export const SHOPPING_TITLE = 'Product sales';

export const SHOPPING_OBJECTIVE: ShoppingObjectiveConfig = {
  title: SHOPPING_TITLE,
  base: SHOPPING_BASE,
  subtitle: 'Standard Shopping — product ads with image, title and price straight from your Merchant Center feed',
  icon: Store,
  goal: 'Product sales from your feed',
  emptyHint: 'Show your products — with their photo, title and price — right in Google search results. Link a Merchant Center feed and every product becomes an ad.',
};
